import { Spinner as ChakraSpinner, SpinnerProps as ChakraSpinnerProps } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';

const SpinnerStyles: ComponentStyleConfig = {
  baseStyle: {
    color: 'primaryThemeColour.400',
  },
};

const Spinner = ({ size = 'md', speed = '0.45s', thickness = '2px', ...props }: ChakraSpinnerProps) => (
  <ChakraSpinner data-testid="spinner" size={size} speed={speed} thickness={thickness} {...props} />
);

export { SpinnerStyles, Spinner };
